
import { useState } from 'react';

const upcomingEvents = [
  {
    date: '2025年2月15日',
    time: '19:00 - 21:00',
    title: '糖尿病治療の最新動向',
    location: '奄美市医師会館',
    type: '学術講演会'
  },
  {
    date: '2025年2月28日',
    time: '18:30 - 20:00',
    title: '理事会',
    location: 'オンライン開催',
    type: '理事会'
  },
  {
    date: '2025年3月10日',
    time: '14:00 - 16:00',
    title: '在宅医療における薬剤師の役割',
    location: '奄美市医師会館',
    type: '学術講演会'
  },
  {
    date: '2025年3月25日',
    time: '19:00 - 21:00',
    title: '抗菌薬適正使用セミナー',
    location: '奄美市医師会館',
    type: '学術講演会'
  }
];

export function Calendar() {
  const [currentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState<number | null>(15);

  const getDaysInMonth = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    return { firstDay, daysInMonth };
  };

  const { firstDay, daysInMonth } = getDaysInMonth(currentMonth);
  const eventDates = [15, 28];

  const renderCalendarDays = () => {
    const days = [];
    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${i}`} className="aspect-square"></div>);
    }
    for (let day = 1; day <= daysInMonth; day++) {
      const hasEvent = eventDates.includes(day);
      const isSelected = selectedDate === day;
      days.push(
        <button
          key={day}
          onClick={() => setSelectedDate(day)}
          className={`aspect-square flex flex-col items-center justify-center rounded-xl text-base font-medium transition-all cursor-pointer relative ${
            isSelected
              ? 'bg-amber-500 text-white shadow-lg scale-105'
              : hasEvent
              ? 'bg-teal-50 text-slate-900 hover:bg-teal-100'
              : 'text-slate-700 hover:bg-gray-100'
          }`}
        >
          {day}
          {hasEvent && !isSelected && (
            <div className="absolute bottom-1.5 w-1.5 h-1.5 bg-teal-500 rounded-full"></div>
          )}
        </button>
      );
    }
    return days;
  };

  return (
    <section id="calendar" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          <div className="lg:col-span-3">
            <h2 className="text-4xl font-bold text-slate-900 mb-8">
              学術講演会・理事会予定
            </h2>
            <div className="bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
              <div className="bg-slate-900 text-white rounded-2xl px-6 py-4 flex items-center justify-between mb-6">
                <button className="w-10 h-10 flex items-center justify-center hover:bg-white/10 rounded-lg transition-colors cursor-pointer">
                  <i className="ri-arrow-left-s-line text-2xl"></i>
                </button>
                <h3 className="text-xl font-bold">
                  {currentMonth.getFullYear()}年 {currentMonth.getMonth() + 1}月
                </h3>
                <button className="w-10 h-10 flex items-center justify-center hover:bg-white/10 rounded-lg transition-colors cursor-pointer">
                  <i className="ri-arrow-right-s-line text-2xl"></i>
                </button>
              </div>

              <div className="grid grid-cols-7 gap-2 mb-3">
                {['日', '月', '火', '水', '木', '金', '土'].map((day) => (
                  <div
                    key={day}
                    className="aspect-square flex items-center justify-center text-sm font-semibold text-gray-500"
                  >
                    {day}
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-7 gap-2">
                {renderCalendarDays()}
              </div>

              <button className="w-full mt-8 px-6 py-3.5 bg-teal-600 text-white rounded-xl font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
                <i className="ri-calendar-line text-xl"></i>
                Googleカレンダーと同期
              </button>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h3 className="text-3xl font-bold text-slate-900 mb-8">今後の予定</h3>
            <div className="space-y-4">
              {upcomingEvents.map((event, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-6 border-l-4 border-amber-500 shadow-md hover:shadow-lg transition-all cursor-pointer"
                >
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0">
                      <div className="text-amber-600 font-bold text-lg">
                        {event.date.split('年')[1].split('月')[0]}月
                      </div>
                      <div className="text-amber-600 font-bold text-2xl">
                        {event.date.split('月')[1].replace('日', '')}
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="inline-block px-3 py-1 bg-teal-100 text-teal-700 text-xs font-semibold rounded-full mb-2">
                        {event.type}
                      </div>
                      <h4 className="text-slate-900 font-bold text-lg mb-2">
                        {event.title}
                      </h4>
                      <div className="flex items-center gap-4 text-sm text-gray-600">
                        <div className="flex items-center gap-1.5">
                          <i className="ri-time-line"></i>
                          <span>{event.time}</span>
                        </div>
                      </div>
                      <div className="flex items-center gap-1.5 text-sm text-gray-600 mt-1">
                        <i className="ri-map-pin-line"></i>
                        <span>{event.location}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
